import React from "react";
import { LeafIcon } from "lucide-react";
import { CtaButton } from "../CtaButton";
import { Countdown } from "../Countdown";
import { ScarcityBar } from "../ScarcityBar";
import { images } from "../../data/content";
export function Hero() {
  return <header className="w-full bg-cream px-5 pb-16 pt-8 md:pb-24 md:pt-12" data-id="element-204" data-mp="cxxo1mtwnx8q">
      <div className="mx-auto flex max-w-4xl flex-col items-center text-center" data-id="element-205" data-mp="hwinhk1c2cw4">
        <div className="flex items-center gap-2 text-brand-olive" data-id="element-206" data-mp="mszcshk9qxas">
          <LeafIcon className="h-6 w-6" aria-hidden="true" data-id="element-207" data-mp="qvdtow4dnmzf" />
          <span className="font-display text-xl tracking-[0.12em]" data-id="element-208" data-mp="qtt13c1mie47">THE AROMA LAB™</span>
        </div>

        <p className="mt-5 rounded-full border border-brand-sage/40 bg-brand-mist px-4 py-1.5 text-[12px] font-bold uppercase tracking-widest text-brand-olive" data-id="element-209" data-mp="vn45z7mvkkth">
          The Aroma Lab™ Method
        </p>

        <h1 className="mt-5 font-serif text-[36px] font-extrabold leading-[1.08] text-ink [text-wrap:balance] md:text-6xl" data-id="element-210" data-mp="15ifev9blqxtb">
          Create Up to 30 Original Aroma Formulas in 30 Days{" "}
          <span className="italic text-brand-lavender" data-id="element-211" data-mp="9p44i011vv9j">
            — and Turn Your Best Ideas Into Your Own Product Collection
          </span>
        </h1>

        <p className="mt-5 max-w-2xl text-[17px] leading-relaxed text-ink/80 md:text-xl" data-id="element-212" data-mp="3vu95tedzg8hu">
          A step-by-step system I created to help you <strong data-id="element-213" data-mp="3rv8oy1f2ffxh">stop relying on random recipes</strong>, understand how to
          combine aromatic profiles, document your experiments, and develop products that{" "}
          <strong data-id="element-214" data-mp="ng8wqh239l9u">actually feel like your own</strong>.
        </p>

        <img src={images.mainMockup} alt="The Aroma Lab box set with 6 volumes and 5 bonus guides" className="-mx-5 mt-8 w-[calc(100%+2.5rem)] max-w-none md:mx-0 md:w-full md:max-w-3xl" data-id="element-215" data-mp="io90ayl89ai0" />

        <div className="mt-6 w-full" data-id="element-216" data-mp="1b5trrybio8zh">
          <CtaButton id="first-cta" label="I Want Access to The Aroma Lab" sub="Instant Access · One-Time Payment of $27 · Lifetime Access · 7-Day Guarantee" data-id="element-217" data-mp="1b6whi2x3s5dt" />
        </div>

        <div className="mt-8 w-full" data-id="element-218" data-mp="35l0l012k6t7u">
          <Countdown label="This special launch offer ends in:" note="Special launch pricing available for a limited time." data-id="element-219" data-mp="35jywouwj8a86" />
        </div>

        <div className="mt-6 flex w-full justify-center" data-id="element-220" data-mp="2vuxjfchdg6xw">
          <ScarcityBar data-id="element-221" data-mp="2vte3xo3jhzx6" />
        </div>
      </div>
    </header>;
}